module.exports = __webpack_public_path__ + "img/stone_oak.fbe6ccab.jpg";